import saveDeal from './saveDeal';

export default saveDeal;
